const T_PREFIX = "terms-of-use";

export const termsOfUseTrns = {
  title: `${T_PREFIX}.title`,
  effectiveDate: `${T_PREFIX}.effective-date`,

  introductionContent: `${T_PREFIX}.introduction.content`,

  aboutTitle: `${T_PREFIX}.about-business-clone.title`,
  aboutContent: `${T_PREFIX}.about-business-clone.content`,

  descriptionOfServicesTitle: `${T_PREFIX}.description-of-services.title`,
  descriptionOfServicesContent: `${T_PREFIX}.description-of-services.content`,

  userAccountTitle: `${T_PREFIX}.user-account.title`,
  userAccountContent: `${T_PREFIX}.user-account.content`,

  userObligationsTitle: `${T_PREFIX}.user-obligations.title`,
  userObligationsContent: `${T_PREFIX}.user-obligations.content`,

  businessClonsResponsibilitiesTitle: `${T_PREFIX}.business-clons-responsibilities.title`,
  businessClonsResponsibilitiesContent: `${T_PREFIX}.business-clons-responsibilities.content`,

  intellectualPropertyRightsTitle: `${T_PREFIX}.intellectual-property-rights.title`,
  intellectualPropertyRightsContent: `${T_PREFIX}.intellectual-property-rights.content`,

  changesTermsOfUseTitle: `${T_PREFIX}.changes-terms-of-use.title`,
  changesTermsOfUseContent: `${T_PREFIX}.changes-terms-of-use.content`,

  pricingChangesTitle: `${T_PREFIX}.pricing-changes.title`,
  pricingChangesContent: `${T_PREFIX}.pricing-changes.content`,

  sellerPriceChangesTitle: `${T_PREFIX}.seller-price-changes.title`,
  sellerPriceChangesContent: `${T_PREFIX}.seller-price-changes.content`,

  disputeResolutionTitle: `${T_PREFIX}.dispute-resolution.title`,
  disputeResolutionContent: `${T_PREFIX}.dispute-resolution.content`,

  prohibitedActionsTitle: `${T_PREFIX}.prohibited-actions.title`,
  prohibitedActionsContent: `${T_PREFIX}.prohibited-actions.content`,

  privacyPolicyTitle: `${T_PREFIX}.privacy-policy.title`,
  privacyPolicyContent: `${T_PREFIX}.privacy-policy.content`,

  useOfCookiesTitle: `${T_PREFIX}.use-of-cookies.title`,
  useOfCookiesContent: `${T_PREFIX}.use-of-cookies.content`,

  rightsOfPartiesTitle: `${T_PREFIX}.rights-of-parties.title`,

  userRightsTitle: `${T_PREFIX}.rights-of-parties.user-rights-title`,
  userRightsContent: `${T_PREFIX}.rights-of-parties.user-rights-content`,

  userObligationsSecondTitle: `${T_PREFIX}.rights-of-parties.user-obligations-title`,
  userObligationsSecondContent: `${T_PREFIX}.rights-of-parties.user-obligations-content`,

  businessClonRightsTitle: `${T_PREFIX}.rights-of-parties.business-clon-rights-title`,
  businessClonRightsContent: `${T_PREFIX}.rights-of-parties.business-clon-rights-content`,

  businessClonObligationsTitle: `${T_PREFIX}.rights-of-parties.business-clon-obligations-title`,
  businessClonObligationsContent: `${T_PREFIX}.rights-of-parties.business-clon-obligations-content`,

  secondDisputeResolutionTitle: `${T_PREFIX}.second-dispute-resolution.title`,
  secondDisputeResolutionContent: `${T_PREFIX}.second-dispute-resolution.content`,

  terminationOfUseTitle: `${T_PREFIX}.termination-of-use.title`,
  terminationOfUseContent: `${T_PREFIX}.termination-of-use.content`,

  miscellaneousProvisionsTitle: `${T_PREFIX}.miscellaneous-provisions.title`,
  miscellaneousProvisionsContent: `${T_PREFIX}.miscellaneous-provisions.content`,

  contactInfoTitle: `${T_PREFIX}.contact-information.title`,
  contactInfoContent: `${T_PREFIX}.contact-information.content`,
};
